import React, { forwardRef, useState } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import * as S from './styles';
import { SingleSelect } from './SingleSelect/SingleSelect';
import { MultiSelect } from './MultiSelect/MultiSelect';
import { ChevronDown } from '@olxbr/ds-icons';
/**
 * Componente Chips do Design System OLX
 */
export const Chips = forwardRef((props, ref) => {
  const {
    children,
    'aria-label': ariaLabel,
    icon,
    variant,
    disabled,
    onAction,
    SelectionItens = [],
    defaultSelectedItemIndex
  } = props;
  const [selected, setSelected] = useState(false);
  const handleSelected = e => {
    setSelected(!selected);
    onAction === null || onAction === void 0 ? void 0 : onAction(e);
  };
  const handleSelectedItems = selected => {
    if (props.setSelectedItems) {
      props.setSelectedItems(selected);
    }
  };
  return React.createElement(React.Fragment, null, (variant === 'default' || variant === 'action') && React.createElement(S.ButtonStylized, {
    "data-ds-component": "DS-Chips",
    "aria-label": ariaLabel,
    "aria-checked": selected,
    className: "".concat(selected ? 'selected' : ''),
    disabled: disabled,
    onClick: handleSelected
  }, icon && React.createElement(S.IconWrapper, {
    "aria-hidden": "true",
    "data-testid": "icon-left"
  }, icon), React.createElement("span", {
    className: (children === null || children === void 0 ? void 0 : children.length) === 1 ? 'oneValue' : ''
  }, children), variant === 'action' && React.createElement(S.IconWrapper, {
    "aria-hidden": "true",
    "data-testid": "icon-left"
  }, React.createElement(ChevronDown, null))), variant === 'multi-selection' && React.createElement(MultiSelect, {
    SelectionItens: SelectionItens,
    onSelectedChange: handleSelectedItems,
    ref: ref
  }), variant === 'single-selection' && React.createElement(SingleSelect, {
    SelectionItens: SelectionItens,
    defaultSelectedItemIndex: defaultSelectedItemIndex,
    onSelectedChange: handleSelectedItems,
    ref: ref
  }));
});
Chips.displayName = 'Chips';